export default __webpack_public_path__ + "static/commercial-2a7e46c99392684623876ff43ac9db26.mp3";